import styled, { css } from 'styled-components';
import DatePicker from 'react-datepicker';

export const Container = styled.div`
  background: ${(props) => props.theme.colors.white};
  height: 48px;
  width: 100%;
  max-width: ${(props) => (props.maxWidth ? `${props.maxWidth}px` : '100%')};
  display: flex;
  align-items: center;
  position: relative;
  ${(props) =>
    props.disabled &&
    css`
      opacity: 0.5;
    `}

  .icon {
    color: ${(props) => props.theme.colors.black};
    font-size: 20px;
    position: absolute;
    right: 10px;
    z-index: 1;
  }
  .react-datepicker-wrapper {
    display: flex;
    flex: 1;
    height: 48px;
  }
`;

export const InputText = styled(DatePicker)`
  display: flex;
  flex: 1;
  height: 48px;
  width: 100%;
  padding: 0 16px;
  border: 0;
  font-family: Poppins;
  font-size: 14px;
  font-weight: normal;
  border-radius: 5px;
  border: 1px solid #d1d1d1;

  &::placeholder {
    color: #d1d1d1;
    text-align: ${(props) =>
      props.placeHolderAlign ? `${props.placeHolderAlign}` : 'start'};
  }
  ${(props) =>
    props.hasIcon
      ? css`
          padding-left: 30px;
        `
      : css`
          padding-left: 10px;
        `}
`;
